// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.2";import * as Sentry from '@sentry/nextjs'
import { isSentryEnabled } from 'shared/constants'

if (isSentryEnabled) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_APP_ENV,
    release: process.env.NEXT_PUBLIC_CODE_VERSION,

    // Add optional integrations for additional features
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 0,
    // Enable logs to be sent to Sentry
    enableLogs: true,

    ignoreErrors: [/metamask extension not found/i, /failed to connect to metamask/i],

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    // TODO: Temporary, set to 0 to disable replays until we decide on the sampling strategy
    replaysSessionSampleRate: 0,

    // Define how likely Replay events are sampled when an error occurs.
    // TODO: Temporary, set to 0 to disable replays until we decide on the sampling strategy
    replaysOnErrorSampleRate: 0,

    // Enable sending user PII (Personally Identifiable Information)
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
  })
}

export const onRouterTransitionStart = (
  ...args: Parameters<typeof Sentry.captureRouterTransitionStart>
): void => {
  if (!isSentryEnabled) return
  return Sentry.captureRouterTransitionStart(...args)
}
